import { computed, openBlock, createBlock, Teleport, createVNode, TransitionGroup, withCtx, createElementBlock, Fragment, renderList, resolveDynamicComponent, mergeProps } from "vue";
import { useModalStore } from "../../uikit.stores/modal.es.js";
/* empty css                     */
const _sfc_main = {
  __name: "ModalWrapper",
  setup(__props) {
    const modalStore = useModalStore();
    const modals = computed(() => modalStore.modals);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(TransitionGroup, { name: "modal-animation" }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(modals.value, (modal) => {
              return openBlock(), createElementBlock("div", {
                key: modal.id
              }, [
                (openBlock(), createBlock(resolveDynamicComponent(modal.component), mergeProps({ ref_for: true }, modal.props), null, 16))
              ]);
            }), 128))
          ]),
          _: 1
        })
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=ModalWrapper.vue.es.js.map
